import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { changePassword } from '../../../actions';
import { renderInput } from '../../forms/newcaso/Fields'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import _ from 'lodash';

class ModelosForm extends Component {
    componentDidMount() {
    }
    onSubmit(data){
        this.props.changePassword(data);
        this.props.toggler();
        this.props.reset();
    }
    render(){
        const { handleSubmit } = this.props;

        return(

            <Modal className="modal-md modal-dialog-centered" isOpen={this.props.show} toggle={this.props.toggler}>
                <ModalHeader toggle={this.props.toggler}>Cambiar contraseña</ModalHeader>
                <ModalBody>
                    <form ref="formAddress" className="modal-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                        <div className="form-row">
                            <Field
                                name="old_password"
                                type="password"
                                label="Contraseña actual"
                                col="col-md-12"
                                component={renderInput}
                            />
                            <Field
                                name="new_password"
                                type="password"
                                label="Nueva contraseña"
                                col="col-md-12"
                                component={renderInput}
                            />
                            <Field
                                name="new_password2"
                                type="password"
                                label="Repita nueva contraseña"
                                col="col-md-12"
                                component={renderInput}
                            />
                        </div>
                        <div className="modal-form-actions">
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" onClick={handleSubmit(this.onSubmit.bind(this))}>Cambiar contraseña</Button>{' '}
                </ModalFooter>
            </Modal>

        )
    }
}
function mapStateToProps(state) {
    return { user: state.user };
}

ModelosForm = reduxForm({
    form: 'changePassword',
})(ModelosForm);



export default ModelosForm = connect(mapStateToProps, {
    changePassword
})(ModelosForm);


// WEBPACK FOOTER //
// ./resources/assets/js/components/settings/user/ChangePassword.jsx